import React, { createContext, useContext, useState, ReactNode } from 'react';

interface HomeScrollContextType {
    isHomeScrolled: boolean;
    setIsHomeScrolled: (scrolled: boolean) => void;
}

const HomeScrollContext = createContext<HomeScrollContextType | undefined>(undefined);

export const useHomeScroll = () => {
    const context = useContext(HomeScrollContext);
    if (context === undefined) {
        throw new Error('useHomeScroll must be used within a HomeScrollProvider');
    }
    return context;
};

interface HomeScrollProviderProps {
    children: ReactNode;
}

export const HomeScrollProvider: React.FC<HomeScrollProviderProps> = ({ children }) => {
    const [isHomeScrolled, setIsHomeScrolled] = useState(false);

    return (
        <HomeScrollContext.Provider value={{ isHomeScrolled, setIsHomeScrolled }}>
            {children}
        </HomeScrollContext.Provider>
    );
};
